"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var evaluateStringVariable_1 = require("./evaluateStringVariable");

var evaluateToggleFunction_1 = require("./evaluateToggleFunction");

var utils_1 = require("../utils");

exports.evaluateStyleEvent = function (styleEvent, variableDictionary) {
  var value = {
    className: evaluateStringVariable_1.evaluateStringVariable(styleEvent.className, variableDictionary)
  };
  if (utils_1.hasValue(styleEvent.end)) value.end = evaluateToggleFunction_1.evaluateToggleFunction(styleEvent.end, variableDictionary);
  if (utils_1.hasValue(styleEvent.start)) value.start = evaluateToggleFunction_1.evaluateToggleFunction(styleEvent.start, variableDictionary);
  return value;
};